import React from 'react';
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Icon from 'components/Icon';
import Glyph from 'components/Glyph';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import TextWithGlyph from 'components/TextWithGlyph';

const Header = ({
  headerRef,
  onCloseButtonClick,
  url,
  name,
}: {
  headerRef: React.RefObject<HTMLHeadingElement>;
  url: string;
  onCloseButtonClick: () => void;
  name: string;
}) => (
  <header
    ref={headerRef}
    className="MultiImageFilePreviewModal-header"
    data-testid="multi-imagefile-preview-modal-header"
  >
    <MediaObject center figure="right" className="MultiImageFilePreviewModal-header-inner">
      <TextWithGlyph
        glyph="image"
        glyphSize="medium"
        truncate
        data-testid="multi-imagefile-preview-modal-header-filename"
      >
        {name}
      </TextWithGlyph>
      <Buttons reset="none">
        <Link
          href={url}
          target="_blank"
          color="whiteout"
          className="MultiImageFilePreviewModal-viewOriginalButton"
          data-testid="multi-imagefile-preview-modal-header-new-tab-link"
        >
          <Icon size="medium" name="external-link" />
          Open in a new tab
        </Link>
        <Button
          aria-label="Close"
          className="CloseButton"
          color="whiteout"
          level="icon"
          onClick={onCloseButtonClick}
        >
          <Glyph name="close" solo />
        </Button>
      </Buttons>
    </MediaObject>
  </header>
);

export default Header;
